import React, { useEffect, useContext } from "react";
import styles from "./Logout.module.scss";
import logout from "../../img/logout.svg";
import { Context } from "../../index";
import { useObserver } from "mobx-react-lite";
import { useNavigate } from "react-router-dom";

const Logout = () => {
  const navigate = useNavigate();
  const { store } = useContext(Context);

  const { showMainPage } = useObserver(() => ({
    isAuth: store.isAuth,
    registred: store.registred,
    showMainPage: store.showMainPage,
  }));

  useEffect(() => {
    if (showMainPage) {
      navigate("/login");
    }
  }, [showMainPage]);

  return (
    <button className={styles.logout} onClick={() => store.logout()}>
      <img src={logout} alt="logout" />
    </button>
  );
};

export default Logout;
